var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProjectScaffold',[_vm._v(" PROJECT ORIGIN ")])}
var staticRenderFns = []

export { render, staticRenderFns }